import { put, select } from 'redux-saga/effects';
import { apiAction, pageContext } from 'ctm-util-functions';

export const postPrefillAction = function* () {
    yield put({ type: 'PREFILL_QUOTE_START' });
    const attempt = yield yield select((state) => state.getIn(['vertical', 'quote', 'form', 'helpers', 'prefill', 'attempt'])) || 0;

    yield put({
        type: 'SET_VALUE',
        value: attempt + 1,
        stateKey: 'vertical.quote',
        identifier: 'helpers.prefill.attempt'
    });
    const apiSchema = {
        url: 'journey/initial',
        type: 'POST',
        requestAction: 'POST_PAYLOAD',
        requestPayload: 'journey',
        failureType: 'non-fatal'
    };
    yield put(apiAction(apiSchema, pageContext.getProps().pageState, apiSchema.restArgs, apiSchema.baseUrl));
};
